import { fetch } from '@/plugins/axios.js';
import site from '@/utils/site';
import store from '@/store'

const apiUrl = {
  newLang: `/language/info/lan`, // 语言 新接口
};

let lang = '';
// 异步函数来获取语言
const getNewLang = async () => {
  try {
    // 获取地址栏中的语种标识
    const arr = window.location.pathname.split('/');
    const res = await fetch(`${apiUrl.newLang}/${arr[2]}/${site}`);
    return res.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

// 异步函数来初始化语言
const initLangFun = async () => {
  const arr = window.location.pathname.split('/');
  let LANGUAGES = [];
  try {
    const data = await getNewLang();
    if(data && data.language_code) {
      LANGUAGES.push(data.language_code);
      store.dispatch('common/changeNewLang', LANGUAGES)
    }
  } catch (error) {
    console.error(error);
  }
  if (arr[1] === 'business' || arr[1] === 'consumer') {
    lang = LANGUAGES.includes(arr[2]) ? `lan/${arr[2]}` : 'lan/en';
  } else {
    lang = 'consumer/en';
  }
};

// 确保在模块加载时初始化语言
initLangFun();

// 提供一个异步函数来确保 lang 已经初始化
export const getInitLang = async () => {
  if (!lang) {
    await initLangFun();
  }
  return lang;
};

// 导出 lang 作为默认导出
export default lang;
